import { Box, CircularProgress } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import { useNavigate, useParams } from 'react-router-dom';
import { ApiError, DetailView } from '@pro4-erp/core-web';
import { useTranslation } from 'react-i18next';
import Details from '../components/Details';
import { Certificate } from '../types';
import { getCertificateById } from '../api/getCertificateById';
import Products from '../components/Products';
import Locations from '../components/Locations';

const DetailPage = () => {
  const { id } = useParams<{ id: string }>() as { id: string };

  const { t } = useTranslation();
  const navigate = useNavigate();

  const query = useQuery<Certificate, ApiError>(['offers-id', id], () => getCertificateById(id), {
    refetchOnWindowFocus: false,
  });

  if (query.isLoading) {
    return (
      <Box>
        <Box
          sx={{
            width: '100vw',
            height: '100vh',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <CircularProgress size={100} />
        </Box>
      </Box>
    );
  }

  if (query.isError) {
    return <p>{query.error.message}</p>;
  }

  return (
    <Box sx={{ mt: 1 }}>
      <DetailView
        childrenSx={{ padding: '2rem' }}
        title={
          <DetailView.Title>{t('Certificate', { defaultValue: 'Certificate' })}</DetailView.Title>
        }
        onGoBack={() => navigate('/client-certificates')}
        tabs={[
          { id: 'details', title: t('Details', { defaultValue: 'Details' }) },
          { id: 'location', title: t('Locations', { defaultValue: 'Locations' }) },
          { id: 'products', title: t('MDRProducts', { defaultValue: 'MDRProducts' }) },
        ]}
        defaultTab="details"
      >
        {({ TabContent }) => (
          <>
            <TabContent tab="details">
              <Details certificate={query.data} />
            </TabContent>
            <TabContent tab="location">
              <Locations locations={query.data.locations} />
            </TabContent>
            <TabContent tab="products">
              <Products products={query.data.mdrProducts} />
            </TabContent>
          </>
        )}
      </DetailView>
    </Box>
  );
};

export default DetailPage;
